interface LoadingProps {
	text?: string;
}

export default function Loading(props: LoadingProps) {
	const { text } = props;
	return (
		<div className="loading-container">
			<div className="lds-grid">
				<div />
				<div />
				<div />
				<div />
				<div />
				<div />
				<div />
				<div />
				<div />
			</div>
			{text && <p>{text}</p>}
		</div>
	);
}
